.card,
.cardDisabled {
  display: flex;
  flex-direction: column;
  padding: 12px;
  border: 1px solid var(--tuna-palette-divider);
  border-radius: var(--tuna-shape-radius-md);
  background: var(--tuna-palette-background-paper);
}

.cardDisabled {
  opacity: 0.5;
}

.heading {
  font-size: var(--tuna-typography-fontSize-lg);
  font-weight: 600;
  margin: 0 0 8px 0;
}

.endingChord {
  font-size: var(--tuna-typography-fontSize-xl);
  margin: 0 0 4px 0;
}

.tagLabel {
  font-size: var(--tuna-typography-fontSize-md);
  color: var(--tuna-palette-text-secondary);
  margin: 0 0 8px 0;
}

.actions {
  display: flex;
  gap: 8px;
}

.suppression {
  font-size: var(--tuna-typography-fontSize-md);
  color: var(--tuna-palette-text-secondary);
  margin: 0;
}
